interface Font {
  name: string
  url: string
}

export class Theme {
  public constructor(public cssVariables: object, public fonts: Font[] = []) {}
}
